import global from './global-variables';
import $ from 'jquery';
window.jQuery = $;
import './vendor/jquery.validate.min.js';
import './vendor/additional-methods.min.js';
import utils from '../patterns/utils';

export default () => {

  $('#signup-form').validate({
    focusInvalid: false,
    rules: {
      'firstName': {
        required: true,
        pattern: "^[-a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð,.'''\s]+$",
      },
      'lastName': {
        required: true,
        pattern: "^[-a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð,.'''\s]+$",
      },
      'email': {
        required: true,
        pattern: "^(([0-9a-zA-Z])+([-._\\'+&]))*[0-9a-zA-Z]+@([-0-9a-zA-Z]+[.])+[a-zA-Z]{2,6}$",
      },
      'zipCode': {
        required: true,
        pattern: "^[0-9]{5}(?:-[0-9]{4})?$",
      },
      'subscription-option': {
        required: true
      },
      'eligibility': {
        required: true
      }
    },
    showErrors: function (errorMap, errorList) {
      // The arguments in errorList contain only those elements currently validated.
      // Refer to the form.successList for all the valid field,
      // and remove the error message that's associated to it.
      // Ref: https://jqueryvalidation.org/validate/  => showErrors

      var outputErr = [];
      this.successList.forEach((e) => {
        const targetName = e.name;
        const targetElements = $(`[name='${targetName}']`);
        const errorElement = $(`#${targetName}-error.form-error`);

        $(targetElements).removeClass('error');
        $(targetElements).removeAttr('aria-labelledby');
        errorElement.addClass('hidden');
      });

      const allErrorElement = $('#all-fields-required-error .form-error');
      errorList.forEach((error) => {
        const targetName = error.element.name;
        const { method } = error;
        const targetElements = $(`[name='${targetName}']`);
        const errorElement = $(`#signup-form #${targetName}-error `);
        const errorMessage = $(`#signup-form #${targetName}-error span`);


        var errorsArr = targetName + " - " + errorMessage.text();

        outputErr.push(errorsArr);

        targetElements.addClass('error');
        targetElements.attr('aria-labelledby', `${targetName}-error`);
        errorElement.removeClass('hidden');
        allErrorElement.removeClass('hidden');
      });

      var submitData = {
        formName: "sign-up-form",
        errors: outputErr
      }
      window.eventsManager.emit('invalidForm', submitData);
    },
    invalidHandler: function () {
      const allErrorElement = $('#all-fields-required-error');
      setTimeout(()=> {
        allErrorElement.focus();
      }, 100);
    },
    submitHandler: function (form) {
      //Submit the form
      const formData = $(form).serializeArray();

      window.eventsManager.emit('validForm', { formName: "sign-up-form" });

      const arr = jQuery.map(formData , function(n, i){
        if(n.name == "promotional-emails") {
          window.eventsManager.emit('validForm', { formName: "sign-up-form-RM-optin"});
        }
      });

      var questions = [
        $("[name='subscription-option']:checked"),
        $("[name='promotional-emails']:checked"),
        $("[name='eligibility']:checked")
      ];
      window.eventsManager.emit('validFormWithQuestions', {
        formName: "sign-up-form",
        questions: questions
      });

      const payload = formData.reduce((acc, item) => {
        if (item.name === "promotional-emails" || item.name === "eligibility") {
          acc[item.name] = item.value === "true" ? true : false;
        } else {
          acc[item.name] = item.value;
        }
        return acc;
      }, {
        "form_name": "form_sublocade_dtc_sign_up",
        "consent": true,
        "promotional-emails": false, // default value
      });

      fetch(global.CRM_API_ENDPOINT + '/misc/formdata/v1', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          window.location.href = "/sign-up-confirmation";
        } else {
          console.error(JSON.stringify(data));
          if (!window.debug) {
            window.location.href = "/404";
          }
        }
      })
      .catch(error => {
        console.error(error);
        if (!window.debug) {
          window.location.href = "/404";
        }
      });
    }
  });
}
